import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import utils from 'lib/utils';
import inMemoryJWT from 'services/auth/inMemoryJWT';

const Reauth = () => {
  const history = useHistory();
  const location = useLocation();
  const [message, setMessage] = useState('Reconnecting…');

  useEffect(() => {
    const run = async () => {
      try {
        // Attempt silent refresh using existing refresh flow
        await inMemoryJWT.getRefreshedToken();
      } catch (e) {}

      try {
        // After refresh, go back to where user came from
        const qs = new URLSearchParams(location.search);
        const back = qs.get('back') || '/';
        setMessage('Reconnected. Redirecting…');
        history.replace(back);
      } catch (e) {
        setMessage('Unable to reconnect. Please login again.');
        setTimeout(() => history.replace('/account/login'), 1000);
      }
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
      <div>
        <h3 style={{ textAlign: 'center' }}>{message}</h3>
      </div>
    </div>
  );
};

export default Reauth;


